{
  "de": {
    "todo_list": {
      "actions": {
        "add": "Aufgabenliste erstellen",
        "cancel": "Rückgängig machen",
        "delete_todo_list": "Liste löschen",
        "edit": "Aufgabenliste bearbeiten",
        "new": "Aufgabenliste",
        "save": "Speichern",
        "title": "Listentitel"
      },
      "attributes": {
        "name": "Titel"
      },
      "labels": {
        "assignToLevel": "Einer Ebene zuweisen",
        "createdAt": "Erstellt am",
        "filter_employee": "Verantwortlich",
        "newTodoList": "Neue Aufgabenliste",
        "sort": {
          "created_at_asc": "Älteste zuerst",
          "created_at_desc": "Neueste zuerst",
          "name_lower_asc": "Titel A -> Z",
          "name_lower_desc": "Titel Z -> A"
        }
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Behalten Sie den Überblick darüber, was Sie und Ihr Team zu erledigen haben.",
            "title": "Öffnen Sie eine neue Aufgabenliste"
          }
        }
      },
      "toasts": {
        "create": "Aufgabenliste erfolgreich erstellt",
        "delete": "Aufgabenliste wurde erfolgreich gelöscht",
        "update": "Aufgabenliste wurde erfolgreich aktualisiert"
      },
      "validation": {
        "needTitle": "Titel erforderlich"
      }
    }
  }
}
